<template>
  <b-form-select
    v-if="
      getUserAccountRoles &&
      getUserAccountRoles.length &&
      getUserAccountRoles.length > 1
    "
    :value="getCurrentAccountRoleId"
    @change.native="updateRole($event.target.value)"
  >
    <template slot="first">
      <!-- this slot appears above the options from 'options' prop -->
      <option value="default" disabled>
        {{ $t("label_snapshotSelector_roles") }}
      </option>
    </template>
    <option
      v-for="(item, itemIndex) in getUserAccountRoles"
      :key="itemIndex"
      :value="item.id"
    >
      {{ $t(item.name) }}
    </option>
  </b-form-select>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TemplateRoleSelector",
  data: function () {
    return {};
  },
  methods: {
    updateRole: async function (newValue) {
      await this.$store.dispatch("USER_ACCOUNT_SET_ROLE", newValue);
      await this.$store.dispatch("USERACCOUNTS_GET", newValue);
      await this.$store.dispatch("GET_PERMISSIONS", newValue);
      await this.$router.push("/home");
    },
  },
  computed: {
    ...mapGetters(["getUserAccountRoles", "getCurrentAccountRoleId"]),
  },
};
</script>

<style lang="sass" scoped>

/* components/template/_template-company-selector.vue */
@import "../../assets/css/variables.scss"
.business-selector
  width: 50%
.business-selector-label
  text-align: right
.form-group
  font-family: $font-subtitle-light
@media (max-width: 768px)
  label
    display: none
</style>
